export default __webpack_public_path__ + "static/media/SheetMetalImg2.8d432f6c.jpg";